import React from 'react';
import { Banner as RapydBanner } from '@rapyd/react-ui-library';
import { BannerProps } from '@rapyd/react-ui-library/dist/components/Banner';
import { ThemeBreakpoints } from 'models';

export interface IBannerProps extends BannerProps {}

const Banner = ({
  className,
  name,
  staticSize = ThemeBreakpoints.LARGE,
  ...rest
}: IBannerProps) => {
  return (
    <RapydBanner
      className={className}
      name={name || 'banner'}
      staticSize={staticSize}
      {...rest}
    />
  );
};

export default Banner;
